const MICRO_UNITS_PER_USDC = 1_000_000

export const USDCToString = (microUnits: number): string => {
  return (microUnits / MICRO_UNITS_PER_USDC).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export const microUSDCToDollars = (microUnits: number): number => {
  return microUnits / MICRO_UNITS_PER_USDC
}

export const dollarsToMicroUSDC = (dollars: number): number => {
  return Math.round(dollars * MICRO_UNITS_PER_USDC)
}
